import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesMainComponent } from './roles-main/roles-main.component';
import { AddRoleComponent } from './add-role/add-role.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
  declarations: [RolesMainComponent, AddRoleComponent, EditRoleComponent],
  imports: [CommonModule, FormsModule, MatDialogModule , MatSelectModule]
})
export class RolesModule {}
